<script setup lang="ts">
const bookerTarget = inject<HTMLElement>('bookerTarget')

const { top } = useElementBounding(bookerTarget)

const isVisibleAnimation = inject<Ref<boolean>>('isNavBookerVisible')

const isVisible = computed(() => {
	return top.value < 100
})

// some hacky way to enable animation without interfering with booker end location getBoundingClientRect
watch(
	() => isVisible.value,
	(newValue, oldValue) => {
		if (!newValue && oldValue) {
			setTimeout(() => {
				if (isVisibleAnimation) isVisibleAnimation.value = top.value < 100
			}, 1000)
		} else if (isVisibleAnimation) isVisibleAnimation.value = newValue
	},
)
</script>

<template>
	<div class="sticky-booker" :data-visible="isVisible">
		<GlobalBooker v-if="isVisibleAnimation" nav />
	</div>
</template>

<style scoped lang="scss">
@import './StickyBooker';
</style>
